import { render, staticRenderFns } from "./recentMonthCarbon.vue?vue&type=template&id=af0cdfec&scoped=true&"
import script from "./recentMonthCarbon.vue?vue&type=script&lang=js&"
export * from "./recentMonthCarbon.vue?vue&type=script&lang=js&"
import style0 from "./recentMonthCarbon.vue?vue&type=style&index=0&id=af0cdfec&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0cdfec",
  null
  
)

export default component.exports